export default [
    {
        path: '/main/servicetypes',
        meta: {
            tag: 'list_servicetype',
            name: 'Tipos de Serviço',
            breadcrumb: 'Tipos de Serviço'
        },
        component: () => import(/* webpackChunkName: "servicetypes-list" */ '@/views/main/settings/parameters/serviceTypes/Index.vue'),
        children: [
            {
            path: '',
            name: 'listservicetypes',
            meta: {
                tag: 'list_servicetype',
                menu: 'settings',
                name: 'Tipos de Serviço',
            },
            component: () => import(/* webpackChunkName: "servicetypes-list" */ '@/views/main/settings/parameters/serviceTypes/List.vue')
            },
            {
            path: '/main/servicetype/add',
            name: 'addservicetype',
            meta: {
                tag: 'add_servicetype',
                menu: 'settings',
                name: 'Adicionar | Tipo de Serviço',
                breadcrumb: 'Adicionar Tipo de Serviço'
            },
            component: () => import(/* webpackChunkName: "servicetype-add" */ '@/views/main/settings/parameters/serviceTypes/Add.vue')
            },
            {
            path: '/main/servicetype/:id',
            name: 'editservicetype',
            meta: {
                tag: 'edit_servicetype',
                menu: 'settings',
                name: 'Editar | Tipo de Serviço',
                breadcrumb: 'Editar Tipo de Serviço'
            },
            component: () => import(/* webpackChunkName: "servicetype-edit" */ '@/views/main/settings/parameters/serviceTypes/Edit.vue')
            }
        ]
    }
]